import { Box, Flex } from "@chakra-ui/layout";
import {
  ContextMenu,
  ContextMenuTrigger,
  MenuItem,
  SubMenu,
} from "react-contextmenu";
import { UnidadeImportacao } from "core/features/unidades/typings/unidade";

import DataGrid, { RowRendererProps, Row as GridRow } from "react-data-grid";
import { columns } from "../columns";
import { Popover } from "antd";
import { IoMdAlert } from "react-icons/io";

function RowRenderer(props: RowRendererProps<UnidadeImportacao>) {
  return (
    <ContextMenuTrigger
      id="grid-context-menu"
      collect={() => ({ rowIdx: props.rowIdx })}
    >
      <GridRow {...props} />
    </ContextMenuTrigger>
  );
}

function TabelaImportacao({
  setData,
  data,
  onRowDelete,
  onRowInsertAbove,
  onRowInsertBelow,
}: {
  setData: any;
  data: any[];
  onRowDelete: any;
  onRowInsertAbove: any;
  onRowInsertBelow: any;
}) {
  return (
    <Box mt="32px" width="100%" overflowX="auto" minH="350px">
      <DataGrid
        rowRenderer={RowRenderer}
        cellNavigationMode="CHANGE_ROW"
        onRowsChange={setData}
        columns={columns.map((item) => ({
          ...item,
          formatter: ({ row, column }: any) => {
            const errors = row.errors ? row.errors[column.key] ?? [] : [];

            return (
              <Flex
                bg={errors.length ? "red.100" : undefined}
                mx="-16px"
                h="35px"
                px="16px"
              >
                {errors.length ? (
                  <Flex w="20px" pos="relative" mr="4px" alignItems="center">
                    <Popover
                      title="Erros"
                      content={
                        <Box>
                          {errors.map((err: string) => (
                            <p>{err}</p>
                          ))}
                        </Box>
                      }
                    >
                      <IoMdAlert color="red" />
                    </Popover>
                  </Flex>
                ) : null}
                <Flex flex={1} fontWeight={errors.length ? "bold" : undefined}>
                  {row[column.key]}
                </Flex>
              </Flex>
            );
          },
        }))}
        rows={data}
        style={{
          height: "50vh",
        }}
        defaultColumnOptions={{
          resizable: true,
        }}
      />
      <ContextMenu id="grid-context-menu">
        <MenuItem onClick={onRowDelete}>Excluir linha</MenuItem>
        <SubMenu title="Inserir linha">
          <MenuItem onClick={onRowInsertAbove}>Antes</MenuItem>
          <MenuItem onClick={onRowInsertBelow}>Depois</MenuItem>
        </SubMenu>
      </ContextMenu>
    </Box>
  );
}

export default TabelaImportacao;
